import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=2174c9ef&scoped=true"
import script from "./SearchProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchProducts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=2174c9ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2174c9ef",
  null
  
)

export default component.exports